import { messageByKey } from '@app/shared/messaging/util/message-by-key';
import { FormModal } from '@fmnts/api/next';
import { isNotNull } from '@fmnts/core';
import { SelfCheckout } from '@formunauts/self-checkout/domain';

function messageByHttpStatus(status: number) {
  return messageByKey(`http${status}Modal`);
}

/**
 * @param modals Array of modals
 * @param httpStatus The http status code we're looking for or null if fallback should be used.
 * @param fallbackKey
 * Key of the modal that should be used if there is no modal specific to this http status code
 *
 * @returns
 * The modal for the http status code or the fallback modal
 */
export function findHttpModalOrGenericFallback(
  modals: readonly FormModal[],
  httpStatus: number | null,
  fallbackKey: string = 'genericErrorModal',
) {
  const modal =
    // Look for a modal matching the status code
    (isNotNull(httpStatus)
      ? modals.find(messageByHttpStatus(httpStatus))
      : undefined) ??
    // No luck - so we look for the modal with the general error message
    modals.find(messageByKey(fallbackKey));

  if (!modal) {
    throw new Error(
      `Missing general error modal with expected key ${fallbackKey}`,
    );
  }

  return modal;
}

export function getEmptyStateForGetForm(
  error: SelfCheckout.SelfCheckoutError,
): {
  text: string;
  translate?: boolean;
} {
  const emptyStateWith = (
    text: string,
    translate?: boolean,
  ): { text: string; translate?: boolean } => ({
    text,
    translate: translate !== undefined ? translate : true,
  });
  switch (error._tag) {
    case 'SelfCheckoutCompletedError':
      return emptyStateWith('verify_unsubscribed');
    case 'SelfCheckoutCustomError': {
      switch (error.status) {
        case 500:
          return emptyStateWith('internal_server_error');
        case 410:
          return emptyStateWith('verify_finished');

        default:
          return emptyStateWith('verify_hash_not_found');
      }
    }
    default:
      return emptyStateWith('verify_hash_not_found');
  }
}
